import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router';
import Api from "../../services/Api";
import Header from "../../components/header/Header";

import {RoomInterface, RoomLogInterface, TeamInterface} from "../../interfaces/common";
import {formatAction} from "../../helpers/room";
import {calculateDaysAgo} from "../../helpers/dateFunctions"

const Home = () => {
  const api = Api.getInstance();
  const navigate = useNavigate();
  const [loaded, setLoaded] = useState(false);
  const [teams, setTeams] = useState<Array<TeamInterface>>([]);
  const now = new Date();

  useEffect(() => {
    api.get('start').then(result => {
      setTeams(result.json.teams)
      setLoaded(true)
    })
  }, [])


  const renderRooms = (rooms: Array<RoomInterface>) => {
    return (
      <>
        <div className="grid grid-cols-4 mt-4 mb-2">
          <div></div>
          <div className="font-medium">Senaste loggning</div>
          <div className="font-medium">Utevistelse</div>
          <div className="font-medium">Aktivitet</div>
        </div>
        {
          rooms.map((room, index) => {
            const lastLog: RoomLogInterface | null = room.logs.length > 0 ? room.logs[0] : null
            let lastLogStr = "-"
            if (lastLog) {
              const daysAgo = calculateDaysAgo(lastLog.date, now)
              if (daysAgo === 0) {
                lastLogStr = "I dag"
              } else if (daysAgo === 1) {
                lastLogStr = "I går"
              } else {
                lastLogStr = daysAgo + " dagar sedan"
              }
            }
            return (
              <div className="grid grid-cols-4 mt-2 cursor-pointer" key={"room_" + index}
                   onClick={() => navigate('/room/' + room.id)}>
                <div className="my-link">{room.name}</div>
                <div>{lastLogStr}</div>
                <div>{formatAction(room.logs, "outdoor")}</div>
                <div>{formatAction(room.logs, "activity")}</div>
              </div>
            )
          })
        }

      </>
    )
  }
  const showTeams = () => {
    if (!loaded) {
      return (
        <div className="mt-4 p-4 bg-my-green rounded-lg">
          <h2 className="text-lg">Laddar...</h2>
        </div>
      )
    } else if (teams.length === 0) {
      return (
        <div className="mt-4 p-4 bg-my-green rounded-lg">
          <h2 className="text-lg">Hoppsan!</h2>
          <p className="mt-4">
            Du tillhör inget team. Prata med adminstratören så löser vi det :-)
          </p>
        </div>
      )
    } else {
      return (
        <>
          {
            teams.map((team, index) => (
              <div key={"team_" + index} className="mt-4 p-4 bg-my-green rounded-lg text-white">
                <h2 className="text-lg">Team {team.name}</h2>
                {renderRooms(team.rooms)}
              </div>
            ))
          }
        </>
      )
    }
  }

  return (
    <>
      <Header breadcrumbs={[{name: "Start"}]}/>
      <div className="page">
        <div className="content">
          {
            api.session.superuser &&
              <div className="mt-4 p-4 bg-my-green rounded-lg text-white">
                  <h2 className="text-lg">Superuser links</h2>
                  <p className="mt-4 my-link"
                     onClick={() => navigate('/logging')}>
                      Sammanfattning av loggning
                  </p>
              </div>
          }
          {showTeams()}
        </div>
      </div>
    </>
  )
}

export default Home